import React, { Component } from "react";
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

import "./Tooltip.scss";

class Tooltip extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
  };
  
  render() {
    const { text, show } = this.props;

    return (
      <CSSTransition in={show} timeout={200} unmountOnExit classNames="tooltip">
        <div className='tooltip'>
          <div className="tooltip-bg">
            {text}
          </div>
        </div>
      </CSSTransition> 
    );
  }
}

export default Tooltip;